/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".observacion[_ngcontent-%COMP%] {\r\n  width: 20%;\r\n}\r\n.btn_l[_ngcontent-%COMP%] {\r\n  align-items: flex-end;\r\n  display: flex;\r\n}\r\n.btn_r[_ngcontent-%COMP%] {\r\n  align-items: flex-start;\r\n  display: flex;\r\n}"];
export { styles as styles };
